





import Vue, { PropType } from 'vue'

type business = 'enterprise' | 'vendor' | 'company' | 'department' | 'relation'
const businessIcons = {
  'enterprise': 'fal fa-university',
  'vendor': 'fal fa-building',
  'company': 'fal fa-store',
  'department': 'fal fa-store-alt',
  'relation': 'fal fa-university'
}

export default Vue.extend({
  name: 'BusinessIcon.vue',
  props: {
    type: {
      type: String as PropType<business>,
      default: 'vendor'
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon () {
      return businessIcons[this.type as business]
    }
  }
})
